/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const VALIDATE_EMAIL = 'VALIDATE EMAIL';
export const VALIDATE_EMAIL_SUCCESS = 'VALIDATE EMAIL SUCCESS';
export const VALIDATE_EMAIL_ERROR = 'VALIDATE EMAIL ERROR';


/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* USER */
export const USER_DETAIL = 'USER_DETAIL';
export const USER_DETAIL_SUCCESS = 'USER_DETAIL_SUCCESS';
export const USER_DETAIL_ERROR = 'USER_DETAIL_ERROR';

/* UPLOAD FILE */
export const UPLOAD_SET = 'UPLOAD_SET';
export const UPLOAD_SET_SUCCESS = 'UPLOAD_SET_SUCCESS';
export const UPLOAD_SET_ERROR = 'UPLOAD_SET_ERROR';
export const UPLOAD_RESET = 'UPLOAD_RESET';

/* REQUEST */
export const REQUEST_LIST = 'REQUEST_LIST';
export const REQUEST_LIST_SUCCESS = 'REQUEST_LIST_SUCCESS';
export const REQUEST_LIST_ERROR = 'REQUEST_LIST_ERROR';
export const REQUEST_PAGE_SET = 'REQUEST_PAGE_SET';
export const REQUEST_SEARCH_SET = 'REQUEST_SEARCH_SET';
export const REQUEST_SEARCH_CHANGE = 'REQUEST_SEARCH_CHANGE';
export const REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT = 'REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const REQUEST_ADD_SET = 'REQUEST_ADD_SET';
export const REQUEST_ADD_MODAL_SET = 'REQUEST_ADD_MODAL_SET';
export const REQUEST_ADD = 'REQUEST_ADD';
export const REQUEST_ADD_SUCCESS = 'REQUEST_ADD_SUCCESS';
export const REQUEST_ADD_ERROR = 'REQUEST_ADD_ERROR';
export const REQUEST_ADD_CHANGE = 'REQUEST_ADD_CHANGE';
export const REQUEST_DETAIL = 'REQUEST_DETAIL';
export const REQUEST_DETAIL_SUCCESS = 'REQUEST_DETAIL_SUCCESS';
export const REQUEST_DETAIL_ERROR = 'REQUEST_DETAIL_ERROR';
export const REQUEST_VIEW_MODAL_SET = 'REQUEST_VIEW_MODAL_SET';
export const REQUEST_EDIT_MODAL_SET = 'REQUEST_EDIT_MODAL_SET';
export const REQUEST_EDIT_SET = 'REQUEST_EDIT_SET';
export const REQUEST_EDIT_CHANGE = 'REQUEST_EDIT_CHANGE';
export const REQUEST_UPDATE = 'REQUEST_UPDATE';
export const REQUEST_UPDATE_SUCCESS = 'REQUEST_UPDATE_SUCCESS';
export const REQUEST_UPDATE_ERROR = 'REQUEST_UPDATE_ERROR';
export const REQUEST_VIEW_TAB_SET = 'REQUEST_VIEW_TAB_SET';
export const REQUEST_UPLOAD_SET = 'REQUEST_UPLOAD_SET';
export const REQUEST_UPLOAD_SET_SUCCESS = 'REQUEST_UPLOAD_SET_SUCCESS';
export const REQUEST_UPLOAD_SET_ERROR = 'REQUEST_UPLOAD_SET_ERROR';
export const REQUEST_UPLOAD_RESET = 'REQUEST_UPLOAD_RESET';

/* SEARCH */
export const SEARCH_REQUEST_TYPE = 'SEARCH_REQUEST_TYPE';
export const SEARCH_REQUEST_TYPE_SUCCESS = 'SEARCH_REQUEST_TYPE_SUCCESS';
export const SEARCH_REQUEST_TYPE_ERROR = 'SEARCH_REQUEST_TYPE_ERROR';
export const SEARCH_EQUIPMENT_DELIVERY_ORDER = 'SEARCH_EQUIPMENT_DELIVERY_ORDER';
export const SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS = 'SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS';
export const SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR = 'SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR';
export const SEARCH_DELIVERY_ORDER_LINE_LOT = 'SEARCH_DELIVERY_ORDER_LINE_LOT';
export const SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const SEARCH_PRIORITY = 'SEARCH_PRIORITY';
export const SEARCH_PRIORITY_SUCCESS = 'SEARCH_PRIORITY_SUCCESS';
export const SEARCH_PRIORITY_ERROR = 'SEARCH_PRIORITY_ERROR';
export const SEARCH_REQUEST_STATUS = 'SEARCH_REQUEST_STATUS';
export const SEARCH_REQUEST_STATUS_SUCCESS = 'SEARCH_REQUEST_STATUS_SUCCESS';
export const SEARCH_REQUEST_STATUS_ERROR = 'SEARCH_REQUEST_STATUS_ERROR';
export const SEARCH_REQUEST_TYPE_DETAIL = 'SEARCH_REQUEST_TYPE_DETAIL';
export const SEARCH_REQUEST_TYPE_DETAIL_SUCCESS = 'SEARCH_REQUEST_TYPE_DETAIL_SUCCESS';
export const SEARCH_REQUEST_TYPE_DETAIL_ERROR = 'SEARCH_REQUEST_TYPE_DETAIL_ERROR';
export const SEARCH_HOSPITAL_SECTION = 'SEARCH_HOSPITAL_SECTION';
export const SEARCH_HOSPITAL_SECTION_SUCCESS = 'SEARCH_HOSPITAL_SECTION_SUCCESS';
export const SEARCH_HOSPITAL_SECTION_ERROR = 'SEARCH_HOSPITAL_SECTION_ERROR';
export const SEARCH_HOSPITAL_SERVICE = 'SEARCH_HOSPITAL_SERVICE';
export const SEARCH_HOSPITAL_SERVICE_SUCCESS = 'SEARCH_HOSPITAL_SERVICE_SUCCESS';
export const SEARCH_HOSPITAL_SERVICE_ERROR = 'SEARCH_HOSPITAL_SERVICE_ERROR';
export const SEARCH_QUOTE_EXPIRATION = 'SEARCH_QUOTE_EXPIRATION';
export const SEARCH_QUOTE_EXPIRATION_SUCCESS = 'SEARCH_QUOTE_EXPIRATION_SUCCESS';
export const SEARCH_QUOTE_EXPIRATION_ERROR = 'SEARCH_QUOTE_EXPIRATION_ERROR';
export const SEARCH_INCOTERM = 'SEARCH_INCOTERM';
export const SEARCH_INCOTERM_SUCCESS = 'SEARCH_INCOTERM_SUCCESS';
export const SEARCH_INCOTERM_ERROR = 'SEARCH_INCOTERM_ERROR';
export const SEARCH_TRANSPORT_TYPE = 'SEARCH_TRANSPORT_TYPE';
export const SEARCH_TRANSPORT_TYPE_SUCCESS = 'SEARCH_TRANSPORT_TYPE_SUCCESS';
export const SEARCH_TRANSPORT_TYPE_ERROR = 'SEARCH_TRANSPORT_TYPE_ERROR';
export const SEARCH_FILE_TYPE = 'SEARCH_FILE_TYPE';
export const SEARCH_FILE_TYPE_SUCCESS = 'SEARCH_FILE_TYPE_SUCCESS';
export const SEARCH_FILE_TYPE_ERROR = 'SEARCH_FILE_TYPE_ERROR';
export const SEARCH_REQUEST_PROCESS_TYPE = 'SEARCH_REQUEST_PROCESS_TYPE';
export const SEARCH_REQUEST_PROCESS_TYPE_SUCCESS = 'SEARCH_REQUEST_PROCESS_TYPE_SUCCESS';
export const SEARCH_REQUEST_PROCESS_TYPE_ERROR = 'SEARCH_REQUEST_PROCESS_TYPE_ERROR';
export const SEARCH_REQUEST_ARTICLE_TYPE = 'SEARCH_REQUEST_ARTICLE_TYPE';
export const SEARCH_REQUEST_ARTICLE_TYPE_SUCCESS = 'SEARCH_REQUEST_ARTICLE_TYPE_SUCCESS';
export const SEARCH_REQUEST_ARTICLE_TYPE_ERROR = 'SEARCH_REQUEST_ARTICLE_TYPE_ERROR';
export const SEARCH_HEALTH_REGISTRY_AGENCY = 'SEARCH_HEALTH_REGISTRY_AGENCY';
export const SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS = 'SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS';
export const SEARCH_HEALTH_REGISTRY_AGENCY_ERROR = 'SEARCH_HEALTH_REGISTRY_AGENCY_ERROR';
export const SEARCH_BMP_AGENCY = 'SEARCH_BMP_AGENCY';
export const SEARCH_BMP_AGENCY_SUCCESS = 'SEARCH_BMP_AGENCY_SUCCESS';
export const SEARCH_BMP_AGENCY_ERROR = 'SEARCH_BMP_AGENCY_ERROR';
export const SEARCH_RISK_TYPE = 'SEARCH_RISK_TYPE';
export const SEARCH_RISK_TYPE_SUCCESS = 'SEARCH_RISK_TYPE_SUCCESS';
export const SEARCH_RISK_TYPE_ERROR = 'SEARCH_RISK_TYPE_ERROR';
export const SEARCH_GHTF = 'SEARCH_GHTF';
export const SEARCH_GHTF_SUCCESS = 'SEARCH_GHTF_SUCCESS';
export const SEARCH_GHTF_ERROR = 'SEARCH_GHTF_ERROR';
export const SEARCH_DIAGNOSTIC_CLASS = 'SEARCH_DIAGNOSTIC_CLASS';
export const SEARCH_DIAGNOSTIC_CLASS_SUCCESS = 'SEARCH_DIAGNOSTIC_CLASS_SUCCESS';
export const SEARCH_DIAGNOSTIC_CLASS_ERROR = 'SEARCH_DIAGNOSTIC_CLASS_ERROR';
export const SEARCH_ISO = 'SEARCH_ISO';
export const SEARCH_ISO_SUCCESS = 'SEARCH_ISO_SUCCESS';
export const SEARCH_ISO_ERROR = 'SEARCH_ISO_ERROR';
export const SEARCH_GT_CERTIFICATE = 'SEARCH_GT_CERTIFICATE';
export const SEARCH_GT_CERTIFICATE_SUCCESS = 'SEARCH_GT_CERTIFICATE_SUCCESS';
export const SEARCH_GT_CERTIFICATE_ERROR = 'SEARCH_GT_CERTIFICATE_ERROR';
export const SEARCH_SERVICE_TYPE = 'SEARCH_SERVICE_TYPE';
export const SEARCH_SERVICE_TYPE_SUCCESS = 'SEARCH_SERVICE_TYPE_SUCCESS';
export const SEARCH_SERVICE_TYPE_ERROR = 'SEARCH_SERVICE_TYPE_ERROR';
export const SEARCH_BIOEQUIVALENCE = 'SEARCH_BIOEQUIVALENCE';
export const SEARCH_BIOEQUIVALENCE_SUCCESS = 'SEARCH_BIOEQUIVALENCE_SUCCESS';
export const SEARCH_BIOEQUIVALENCE_ERROR = 'SEARCH_BIOEQUIVALENCE_ERROR';

/* EQUIPMENT_SCHEDULE_MAINTENANCE */
export const EQUIPMENT_SCHEDULE_MAINTENANCE_LIST = 'EQUIPMENT_SCHEDULE_MAINTENANCE_LIST';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_PAGE_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_PAGE_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_CHANGE = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_CHANGE';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_MODAL_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_MODAL_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_CHANGE = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_CHANGE';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL = 'EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_MODAL_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_MODAL_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_MODAL_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_MODAL_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_CHANGE = 'EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_CHANGE';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_TAB_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_TAB_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_RESET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_RESET';

/* REQUEST_DETAIL */
export const REQUEST_DETAIL_LIST = 'REQUEST_DETAIL_LIST';
export const REQUEST_DETAIL_LIST_SUCCESS = 'REQUEST_DETAIL_LIST_SUCCESS';
export const REQUEST_DETAIL_LIST_ERROR = 'REQUEST_DETAIL_LIST_ERROR';
export const REQUEST_DETAIL_PAGE_SET = 'REQUEST_DETAIL_PAGE_SET';
export const REQUEST_DETAIL_SEARCH_SET = 'REQUEST_DETAIL_SEARCH_SET';
export const REQUEST_DETAIL_SEARCH_CHANGE = 'REQUEST_DETAIL_SEARCH_CHANGE';
export const REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT = 'REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const REQUEST_DETAIL_ADD_SET = 'REQUEST_DETAIL_ADD_SET';
export const REQUEST_DETAIL_ADD_MODAL_SET = 'REQUEST_DETAIL_ADD_MODAL_SET';
export const REQUEST_DETAIL_ADD = 'REQUEST_DETAIL_ADD';
export const REQUEST_DETAIL_ADD_SUCCESS = 'REQUEST_DETAIL_ADD_SUCCESS';
export const REQUEST_DETAIL_ADD_ERROR = 'REQUEST_DETAIL_ADD_ERROR';
export const REQUEST_DETAIL_ADD_CHANGE = 'REQUEST_DETAIL_ADD_CHANGE';
export const REQUEST_DETAIL_DETAIL = 'REQUEST_DETAIL_DETAIL';
export const REQUEST_DETAIL_DETAIL_SUCCESS = 'REQUEST_DETAIL_DETAIL_SUCCESS';
export const REQUEST_DETAIL_DETAIL_ERROR = 'REQUEST_DETAIL_DETAIL_ERROR';
export const REQUEST_DETAIL_VIEW_MODAL_SET = 'REQUEST_DETAIL_VIEW_MODAL_SET';
export const REQUEST_DETAIL_EDIT_MODAL_SET = 'REQUEST_DETAIL_EDIT_MODAL_SET';
export const REQUEST_DETAIL_EDIT_SET = 'REQUEST_DETAIL_EDIT_SET';
export const REQUEST_DETAIL_EDIT_CHANGE = 'REQUEST_DETAIL_EDIT_CHANGE';
export const REQUEST_DETAIL_UPDATE = 'REQUEST_DETAIL_UPDATE';
export const REQUEST_DETAIL_UPDATE_SUCCESS = 'REQUEST_DETAIL_UPDATE_SUCCESS';
export const REQUEST_DETAIL_UPDATE_ERROR = 'REQUEST_DETAIL_UPDATE_ERROR';
export const REQUEST_DETAIL_VIEW_TAB_SET = 'REQUEST_DETAIL_VIEW_TAB_SET';
export const REQUEST_DETAIL_UPLOAD_SET = 'REQUEST_DETAIL_UPLOAD_SET';
export const REQUEST_DETAIL_UPLOAD_SET_SUCCESS = 'REQUEST_DETAIL_UPLOAD_SET_SUCCESS';
export const REQUEST_DETAIL_UPLOAD_SET_ERROR = 'REQUEST_DETAIL_UPLOAD_SET_ERROR';
export const REQUEST_DETAIL_UPLOAD_RESET = 'REQUEST_DETAIL_UPLOAD_RESET';

export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './user/actions';
export * from './upload/actions';
export * from './request/actions';
export * from './equipment_schedule_maintenance/actions';
export * from './request_detail/actions';
export * from './search/actions';